module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app bg-gray"
  }, [_c('section', [_c('hospital-select', {
    on: {
      "selected": _vm.selectHospital
    }
  }), _vm._v(" "), _c('voucher-select', {
    attrs: {
      "list": _vm.voucherList
    },
    on: {
      "selected": _vm.selectVoucher
    }
  })], 1), _vm._v(" "), _c('scroll', {
    staticClass: "from-query",
    staticStyle: {
      "padding-bottom": "2rem"
    },
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('no-record', {
    attrs: {
      "condition": _vm.surveyList,
      "tips": "抱歉，没有问卷记录"
    }
  }), _vm._v(" "), _vm._l((_vm.surveyList), function(survey, index) {
    return _c('section', {
      key: index,
      staticClass: "thick",
      on: {
        "click": function($event) {
          return _vm.goToSurveyEdit(survey)
        }
      }
    }, [_c('div', {
      staticClass: "panel"
    }, [_c('span', [_vm._v("整体满意度")]), _vm._v("    "), _c('span', [_vm._v(_vm._s(survey.degree))]), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "content arr-row f-minor"
    }, [_c('span', [_vm._v("发布时间")]), _vm._v("    "), _c('span', [_vm._v(_vm._s(survey.createTime ? new Date(survey.createTime).format('yyyy-MM-dd hh:mm:ss') : ''))]), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "content f-minor flex-row"
    }, [_c('span', [_vm._v("平台回复")]), _vm._v("    "), _c('span', {
      staticClass: "ellipsis-text"
    }, [_vm._v(_vm._s(survey.feedBack ? survey.feedBack : '未回复'))]), _c('br')])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "page-footer"
  }, [_c('button', {
    staticClass: "btn-ok",
    on: {
      "click": _vm.goToSurveyAdd
    }
  }, [_vm._v("填写问卷反馈")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-035ae332","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/survey/SurveyList.vue
// module id = 777
// module chunks = 0